import React, { useRef } from "react";
import ReactDom from "react-dom";
import PropTypes from "prop-types";
import { useOutsideClick } from "hooks/useOutsideClick";
import clsx from "clsx";

const Modal = ({ visible, children, className, setVisibility }) => {
  const modalBodyRef = useRef();

  const clickOutsideHandler = () => {
    if (visible) {
      setVisibility(false);
    }
  };
  useOutsideClick(modalBodyRef, clickOutsideHandler);

  if (!visible) return null;

  return ReactDom.createPortal(
    <div className={clsx("modal", className)}>
      <div ref={modalBodyRef} className="modal__container">
        {children}
      </div>
    </div>,
    document.body
  );
};

Modal.defaultProps = {
  setVisibility: () => {},
};

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  setVisibility: PropTypes.func,
};

export default Modal;
